import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import useSortedContests from "../contests/hooks/useSortedContests";
import { useAuth } from "../../context/AuthContext";

const RegisteringContests = () => {
  const { contests } = useOutletContext();
  const { userId } = useAuth();
  const { sortedContests, requestSort, sortConfig } = useSortedContests(
    contests || [],
    "deadline",
    "ascending"
  );
  const navigate = useNavigate();

  const handleContestClick = (contestId) => {
    navigate(`/contests/registering/${contestId}`);
  };

  const getSortIndicator = (key) => {
    if (!sortConfig || sortConfig.key !== key) return "";
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  const getTimeRemaining = (deadline) => {
    const now = new Date();
    const contestTime = new Date(deadline);
    const diffMs = contestTime - now;

    if (diffMs <= 0) {
      return "Closed";
    }

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    if (diffHours > 0) {
      return `${diffHours}h ${diffMinutes}m`;
    } else {
      return `${diffMinutes}m`;
    }
  };

  if (!contests || contests.length === 0) {
    return (
      <div className="contests-table-container">
        <p>No registering contests found.</p>
      </div>
    );
  }

  return (
    <div className="open-contests-container">
      <div className="contests-table-container">
        <table className="contests-table">
          <thead>
            <tr>
              {[
                { label: "Name", key: "tournamentName" },
                { label: "Fee", key: "entryFee" },
                { label: "Format", key: "format" },
                { label: "Status", key: "status" },
                { label: "Starts", key: "deadline" },
              ].map(({ label, key }) => (
                <th key={key} onClick={() => requestSort(key)}>
                  {label} {getSortIndicator(key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedContests.map((contest) => {
              const isUserEntered =
                userId &&
                contest.entrants?.some((entrant) => entrant.userId === userId);
              return (
                <tr
                  key={contest._id}
                  onClick={() => handleContestClick(contest._id)}
                  className={
                    contest.status === "Drafting" ? "drafting-contest" : ""
                  }
                >
                  <td>
                    {isUserEntered && (
                      <span title="You have an entry in this contest">⭐ </span>
                    )}
                    {contest.tournamentName}
                  </td>
                  <td>${(contest.entryFee || 0) + (contest.adminFee || 0)}</td>
                  <td>{contest.format}</td>
                  <td>
                    {contest.status === 'Drafting' ? (
                      <span className="drafting-status">Drafting</span>
                    ) : (
                      <span className="registering-status">Registering</span>
                    )}
                  </td>
                  <td>{getTimeRemaining(contest.deadline)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

RegisteringContests.propTypes = {
  // This component is a container component that doesn't receive any props
};

export default RegisteringContests;
